import { Configuration as MsalConfiguration } from "@azure/msal-browser";

const isProduction = import.meta.env.PROD;

const redirectUrl = isProduction
	? (import.meta.env.VITE_MSAL_REDIRECT_URL ?? "")
	: "http://localhost:3007/";

export const msal: MsalConfiguration = {
	auth: {
		clientId: import.meta.env.VITE_MSAL_CLIENT_ID ?? "",
		authority: import.meta.env.VITE_MSAL_AUTHORITY,
		redirectUri: redirectUrl,
	},
	cache: {
		cacheLocation: "localStorage",
		storeAuthStateInCookie: false,
	},
};

export const loginRequest = {
	scopes: ["User.Read"],
};

export const api_s2 = {
	baseURL: import.meta.env.VITE_API_S2_BASE_URL ?? (isProduction ? "https://papi.pymblelc.nsw.edu.au/" : "http://localhost:8000/"),
	scopes: [
		import.meta.env.VITE_API_S2_SCOPES ?? "api://pymble-apis/access",
	],
};

export const app = {
	colorPrimary: "#002f67",
	colorSecondary: "#c8102e",
};

// AI Agent configuration (agent MongoDB ObjectIds — kept in sync with the
// my-pymble-portal config so the pastoral drawer's inline AI assist targets the
// same backend agents).
export const agents = {
	OFFICIAL_RECORDS_AGENT_ID: "681967c2743243b48377d427",
	DEESCALATOR_AGENT_ID: "681968dc743243b48377d428",
	NOTE_TAKER_AGENT_ID: "681969ec743243b48377d42a",
	NOTICE_SUMMARY_AGENT_ID: "684f946b9aad9236910aae8e",
	CARER_AGENT_ID: "6823292f9efb078ab366bb55",
	STUDENT_AGENT_ID: "698a9076fa675497ed6ba76a",
	STUDENT_MCP_AGENT_ID: "699ce4f3874310bdacae25a9",
	CARER_MCP_AGENT_ID: "699ce51f874310bdacae25aa",
};

export const DEV_BYPASS_AUTH = import.meta.env.VITE_DISABLE_AUTH === "true";
